import React from 'react';

const Navigation = () => {
  return (
    <nav style={styles.nav}>
      <ul style={styles.navList}>
        <li style={styles.navItem}>
          <a href="#about" className="neon-button" style={styles.neonButton}>ABOUT</a>
        </li>
        <li style={styles.navItem}>
          <a href="#cv" className="neon-button" style={styles.neonButton}>CV</a>
        </li>
        <li style={styles.navItem}>
          <a href="#articles" className="neon-button" style={styles.neonButton}>ARTICLES</a>
        </li>
        <li style={styles.navItem}>
          <a href="#contact" className="neon-button" style={styles.neonButton}>CONTACT</a>
        </li>
      </ul>
    </nav>
  );
};

const styles = {
  nav: {
    margin: '0 auto',
    width: '100%',
    maxWidth: '1200px',
  },
  navList: {
    display: 'flex',
    justifyContent: 'center',
    listStyle: 'none',
    gap: '1.5rem',
    flexWrap: 'wrap',
    padding: 0,
    margin: 0,
  },
  navItem: {
    margin: 0,
    padding: 0,
  },
  neonButton: {
    display: 'inline-block',
    padding: '0.5rem 1.5rem',
    color: '#f0f', // Neon pink
    textDecoration: 'none',
    border: '1px solid #f0f',
    boxShadow: '0 0 5px #f0f',
    textShadow: '0 0 5px #f0f',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s',
    
    ':hover': {
      backgroundColor: '#f0f',
      color: 'black',
      boxShadow: '0 0 5px #f0f, 0 0 10px #f0f, 0 0 20px #f0f',
    }
  },
};

export default Navigation; 